module.exports = __webpack_public_path__ + "static/roche-press-day-1-895c541334e7ca17e67124e3c67259e0.jpg";